





































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import RequestButton from '@/components/RequestButton'

settings = 
  name: 'ShippingInfoStep'
  vue:
    mixins: [WizardService.step()]
    components: { RequestButton }
    methods:
      validateStep: ->  return true
      onSave: (item) -> 
      saveFields: -> { advance: ['offer_overrides'] }


export default VueOptions.vue settings
